<template>
<div>
    <div class="row" v-if="$gate.isAdmin() || $gate.isAccount() || $gate.isManager() || $gate.isSupervisor()">
        <div id="pdf" class="col-md-12">
            <div class="row mb-2">
                <div class="col-md-4"></div>
                <div class="col-md-4 d-flex justify-content-center">
                    <img src="./../../Images/StepUp_logo.png" alt="StepUp" style="background-size: cover;width: auto; height: 150px;">
                </div>
                <div class="col-md-4"></div>
            </div>
            <div class="col-md-12 row">
                <div class="col-md-6 datepicker-trigger">
                    <!-- <date-picker v-model="dateFilter" range lang="en" /> -->
                    <input
                        type="text"
                        id="datepicker-trigger"
                        placeholder="Select dates"
                        :value="formatDates(dateOne, dateTwo)"
                        class="form-control"
                    >

                    <AirbnbStyleDatepicker
                        :trigger-element-id="'datepicker-trigger'"
                        :mode="'range'"
                        :fullscreen-mobile="true"
                        :date-one="dateOne"
                        :date-two="dateTwo"
                        @date-one-selected="val => { dateOne = val }"
                        @date-two-selected="val => { dateTwo = val }"
                    />
                </div>
                <div class="col-md-6">
                    <multi-select :options="serviceOption"
                            :selected-options="items"
                            placeholder="select services"
                            class="form-control"
                            @select="onSelect">
                </multi-select>
                <button class="btn btn-success mt-2 float-right"  id="search" @click="search">search</button>
                </div>
            </div>
            <div class="col-md-12 mt-2" id="excel">
                <table class="table table-bordered">
                    <thead>
                        <tr>
                            <th width="30%">Product Name</th>
                            <th width="20%">Item</th>
                            <th width="10%">Quantity</th>
                            <th width="10%">Taxable</th>
                            <th width="10%">Discount</th>
                            <th width="10%">VAT 5%</th>
                            <th width="10%">Total (Incl VAT)</th>

                        </tr>
                    </thead>
                    <tbody >
                        <!-- <tr v-for="(option, index) in service.option" :key="index">
                            <td> {{service.name}} </td>
                            <td> {{option.name}} </td>
                            <td> {{option.quantity}} </td>
                            <td> {{ parseFloat(option.Taxable).toFixed(2) }} </td>
                            <td> {{ parseFloat(option.discount).toFixed(2) }} </td>
                            <td> {{ parseFloat(option.VAT).toFixed(2) }} </td>
                            <td> {{ parseFloat(option.price).toFixed(2) }} </td>
                        </tr> -->

                        <tr v-for="(service, index) in Services" :key="index" >
                            <td> {{service.title}} </td>
                            <td> {{service.name}} </td>
                            <td> {{service.quantity}} </td>
                            <td> <strong> {{ service.Taxable | formatAmount }}</strong></td>
                            <td> <strong> {{ service.discount| formatAmount }}</strong></td>
                            <td> <strong> {{ service.VAT | formatAmount }}</strong></td>
                            <td> <strong> {{ service.price| formatAmount }}</strong></td>
                        </tr>
                        <!-- <tr>
                            <td></td>
                            <td> <strong> Total </strong></td>
                            <td> <strong> {{service.quantity}} </strong></td>
                            <td> <strong> {{ parseFloat(service.Taxable).toFixed(2) }} AED</strong></td>
                            <td> <strong> {{ parseFloat(service.discount).toFixed(2) }} AED</strong></td>
                            <td> <strong> {{ parseFloat(service.VAT).toFixed(2) }} AED</strong></td>
                            <td> <strong> {{ parseFloat(service.price).toFixed(2) }} AED</strong></td>
                        </tr> -->


                    </tbody>
                </table>

                <table class="table table-bordered">
                    <thead>
                        <tr>
                            <th>Total Quantity</th>
                            <th>Grand Taxable</th>
                            <th>Grand Discount</th>
                            <th>Grand VAT 5%</th>
                            <th>Grand Total</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td> {{this.grandQuantity}} </td>
                            <td> {{ this.grandTaxable | formatAmount }}</td>
                            <td> {{ this.grandDiscount | formatAmount }}</td>
                            <td> {{ this.grandVAT | formatAmount }}</td>
                            <td> {{ this.grandPrice | formatAmount }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <div class="pull-right" id="print">
            <button class="btn btn-success" @click="print"><i class="fa fa-print"></i></button>
            <!-- <vue-csv-downloader
                :data="Services"
                :fields="product">
                <button class="btn btn-primary"><i class="fa fa-download"></i></button>
            </vue-csv-downloader> -->
            <button class="btn btn-primary hidden-print" @click="excel('excel', 'Service-report')"><i class="fa fa-download"></i></button>
            <button class="btn btn-success hidden-print" @click="pdf"><i class="fa fa-file"></i></button>
        </div>
    </div>
    <div class="row" v-else>
        <notfound></notfound>
    </div>
</div>
</template>

<script>
import html2pdf from 'html2pdf.js'
import VueCsvDownloader from 'vue-csv-downloader'
import { MultiSelect } from 'vue-search-select'
import DatePicker from 'vue2-datepicker'
import format from 'date-fns/format'
export default {
    components: { DatePicker, VueCsvDownloader, MultiSelect },
    data() {
        return {
            Services: [],
            serviceOption: [],
            items: [],
            lastSelectItem: {},
            dateFilter: '',
            dataFilter: {
                staff:'',
            },
            product: ['name','quantity','Taxable','discount', 'VAT', 'price', 'option'],
            dateFormat: 'D MMM',
            dateOne: '',
            dateTwo: ''
        }
    },
    created() {
        this.getServiceOptions()
    },
    methods: {
        formatDates(dateOne, dateTwo) {
            let formattedDates = ''
            if (dateOne) {
                formattedDates = format(dateOne, this.dateFormat)
            }
            if (dateTwo) {
                formattedDates += ' - ' + format(dateTwo, this.dateFormat)
            }
            return formattedDates
            },
        search(){
            axios
            .post('./api/Report/Service-Report', {
               dateFrom: this.dateOne,
                dateTo: this.dateTwo,
                user_id: this.$root.id,
                name: this.$root.staffname,
                filter: this.items,
                ranges: this.ranges
                })
            .then((result) => {
                console.log(result)
                this.Services = result.data.all
                // this.otherservice = result.data.other_service
                // this.location = result.data.location
                // this.trial = result.data.trial
            }).catch((err) => {
                console.log(err)
            });
        },
        print(){
            var printButton = document.getElementById("print")
            printButton.style.visibility = 'hidden'
            var hiddenButton = document.getElementById("search")
            hiddenButton.style.visibility = 'hidden'
            window.print()
            window.close()
            window.location.assign('/Report-Product');
            printButton.style.visibility = 'visible'
            hiddenButton.style.visibility = 'visible'
        },
        getServiceOptions() {
            axios
            .get('./api/Report/Service-Report/options')
            .then((response) => {
                this.serviceOption = response.data.all
            })
            .catch((err) => {
                console.log(err)
            });
        },
        onSelect(items, lastSelectItem) {
            this.items = items
            this.lastSelectItem = lastSelectItem
        },
        pdf() {
            var elements = document.getElementById('pdf')

            var opt = {
            margin: 15,
            filename: 'Service Report.pdf',
            image: {type: 'jpeg', quality: 0.98},
            html2canvas: {scale: 1},
            jsPDF: {
              unit: 'mm',
            //   format: [280, 350],
              orientation: 'landscape'
            }
          }
          html2pdf().set(opt).from(elements).save()
        },
        excel(tableID, filename = '') {
            var downloadLink;
            var dataType = 'application/vnd.ms-excel';
            var tableSelect = document.getElementById(tableID);
            var tableHTML = tableSelect.outerHTML.replace(/ /g, '%20');

            // Specify file name
            filename = filename?filename+'.xls':'excel_data.xls';

            // Create download link element
            downloadLink = document.createElement("a");

            document.body.appendChild(downloadLink);

            if(navigator.msSaveOrOpenBlob){
                var blob = new Blob(['\ufeff', tableHTML], {
                    type: dataType
                });
                navigator.msSaveOrOpenBlob( blob, filename);
            }else{
                // Create a link to the file
                downloadLink.href = 'data:' + dataType + ', ' + tableHTML;

                // Setting the file name
                downloadLink.download = filename;

                //triggering the function
                downloadLink.click();
            }
        }
    },
    computed: {
        grandQuantity() {
            return this.Services.reduce((total, item) => {
                return total + Number(item.quantity)
            }, 0)
        },
        grandPrice() {
            return this.Services.reduce((total, item) => {
                return total + Number(item.price)
            }, 0)
        },
        grandTaxable() {
            return this.Services.reduce((total, item) => {
                return total + Number(item.Taxable)
            }, 0)
            // return this.grandPrice / 1.05
        },
        grandVAT() {
            return this.Services.reduce((total, item) => {
                return total + Number(item.VAT)
            }, 0)
            // return this.grandPrice - this.grandTaxable
        },
        grandDiscount() {
            return this.Services.reduce((total, item) => {
                return total + Number(item.discount)
            }, 0)
        },
    },
    filters:{
        formatAmount: function (value) {
            return parseFloat(value).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        }
    }
}
</script>



// WEBPACK FOOTER //
// resources/js/Report/Report/Service.vue